import {
	Breakpoints,
	Container,
	ContainerPadding,
	Layout,
	Text,
	TextAlignment,
	TokenTextAppearance,
	TokenTextColor,
	Image,
	CTA,
	ContainerGutter,
} from '@volkswagen-onehub/components-core';
import React, { useEffect } from 'react';
import styled from 'styled-components';
import { Environment } from '../../../enviroment';
import { PortalContext } from '../../../context/PortalContext';
import { useTrackingManager } from '../../../tracking/useTrackingManager';
import { getParamsClubVW } from '../../../helpers/get-params-clubvw';
import { StyledSpinner } from '../../styled-spinner/styled-spinner';
import { pageInPath } from '../../../tracking/trackingHelper';
import { useErrorAlert } from '../../../hooks/useErrorAlert';
import { GetPersonUser } from '@esportal/portal-service';

const StyledContainer = styled.div`
	align-content: center;
	padding-top: var(--size-dynamic0130);

	min-height: 70vh;

	@media screen and (min-width: 560px) {
		min-height: 70vh;
	}
`;

export const UserStatusIDKit: React.FC = () => {
	const [isLoading, setIsLoading] = React.useState<boolean>(false);

	const trackingManager = useTrackingManager();
	const { showAlert } = useErrorAlert();
	const { portalService } = React.useContext(PortalContext);
	const { device, url, tc } = getParamsClubVW();

	const { navigationService } = React.useContext(PortalContext);
	const environmentPath = Environment.getInstance().condicionesUsoClubVW;
	const target = navigationService.navigateTo(environmentPath, {});

	useEffect(() => {
		pageInPath('acceptance.app');
		trackingManager.trackClubVWGenericFeatureAppLoad({ contentId: 'acceptance' }, {}, { vehicle: [] });
		trackingManager.trackClubVWFormLoad(
			{
				FormName: 'vw-club-acceptance',
				FormStart: true,
				FormTypeMultiple: ['registration'],
			},
			{ contentId: 'vw-club-acceptance' },
			{ vehicle: [] },
		);
	}, []);

	const handleOnClick = () => {
		if (target) {
			target.push();
		}
	};

	const handleSubmit = () => {
		setIsLoading(true);
		trackingManager.trackClubVWButtonClick(
			'Unirme al club',
			{
				contentId: 'Subscribe Club Volkswagen',
			},
			{ vehicle: [] },
		);

		const request$ = portalService.acceptPerson('NO INFORMADO', device, tc, url);

		request$.subscribe({
			next: (modifiedData: GetPersonUser | null) => {
				if (modifiedData != null) {
					trackingManager.trackClubVWFormSubmissionSuccessMessageLoad(
						{
							FormName: 'vw-club-acceptance',
							FormStart: false,
							FormTypeMultiple: ['registration'],
						},
						{ contentId: 'vw-club-sign_up' },
						{ vehicle: [] },
					);
				} else {
					showAlert();
				}
			},
			error: () => {
				showAlert();
			},
		});
	};

	return (
		<>
			{isLoading ? (
				<StyledSpinner variant="x-large" />
			) : (
				<Container
					wrap={'always'}
					horizontalAlign={'center'}
					padding={{ top: ContainerPadding.dynamic0200, bottom: ContainerPadding.dynamic0200 }}
					stretchContent
				>
					<Container wrap={'always'} horizontalAlign={'center'} stretchContent>
						<Layout
							data-testid="confirm-club__logo-layout"
							appearance={{
								[Breakpoints.default]: [
									{ name: '.', columns: 7 },
									{ name: 'a', columns: 10 },
									{ name: '.', columns: 7 },
								],
								[Breakpoints.b560]: [
									{ name: '.', columns: 8 },
									{ name: 'a', columns: 8 },
									{ name: '.', columns: 8 },
								],
								[Breakpoints.b960]: [
									{ name: '.', columns: 10 },
									{ name: 'a', columns: 4 },
									{ name: '.', columns: 10 },
								],
								[Breakpoints.b1920]: [
									{ name: '.', columns: 11 },
									{ name: 'a', columns: 2 },
									{ name: '.', columns: 11 },
								],
							}}
						>
							<Image
								src="https://vgedonehubappsstaweupro.blob.core.windows.net/storage/images-club/logo_club.svg"
								alt="Logo club VW"
							/>
						</Layout>
					</Container>

					<StyledContainer className="userStatus-section">
						<Layout
							data-testid="userStatus-layout"
							appearance={{
								[Breakpoints.default]: [
									{ name: '.', columns: 1 },
									{ name: 'a', columns: 22 },
									{ name: '.', columns: 1 },
									{ name: '.', columns: 1 },
									{ name: 'b', columns: 22 },
									{ name: '.', columns: 1 },
									{ name: '.', columns: 1 },
									{ name: 'c', columns: 22 },
									{ name: '.', columns: 1 },
								],
								[Breakpoints.b560]: [
									{ name: '.', columns: 1 },
									{ name: 'a', columns: 22 },
									{ name: '.', columns: 1 },
									{ name: '.', columns: 6 },
									{ name: 'b', columns: 12 },
									{ name: '.', columns: 6 },
									{ name: '.', columns: 1 },
									{ name: 'c', columns: 22 },
									{ name: '.', columns: 1 },
								],
								[Breakpoints.b960]: [
									{ name: '.', columns: 1 },
									{ name: 'a', columns: 22 },
									{ name: '.', columns: 1 },
									{ name: '.', columns: 8 },
									{ name: 'b', columns: 8 },
									{ name: '.', columns: 8 },
									{ name: '.', columns: 1 },
									{ name: 'c', columns: 22 },
									{ name: '.', columns: 1 },
								],
								[Breakpoints.b1280]: [
									{ name: '.', columns: 4 },
									{ name: 'a', columns: 16 },
									{ name: '.', columns: 4 },
									{ name: '.', columns: 9 },
									{ name: 'b', columns: 6 },
									{ name: '.', columns: 9 },
									{ name: '.', columns: 3 },
									{ name: 'c', columns: 18 },
									{ name: '.', columns: 3 },
								],
								[Breakpoints.b1600]: [
									{ name: '.', columns: 5 },
									{ name: 'a', columns: 14 },
									{ name: '.', columns: 5 },
									{ name: '.', columns: 9 },
									{ name: 'b', columns: 6 },
									{ name: '.', columns: 9 },
									{ name: '.', columns: 5 },
									{ name: 'c', columns: 14 },
									{ name: '.', columns: 5 },
								],
								[Breakpoints.b1920]: [
									{ name: '.', columns: 6 },
									{ name: 'a', columns: 12 },
									{ name: '.', columns: 6 },
									{ name: '.', columns: 10 },
									{ name: 'b', columns: 4 },
									{ name: '.', columns: 10 },
									{ name: '.', columns: 6 },
									{ name: 'c', columns: 12 },
									{ name: '.', columns: 6 },
								],
								[Breakpoints.b2560]: [
									{ name: '.', columns: 8 },
									{ name: 'a', columns: 8 },
									{ name: '.', columns: 8 },
									{ name: '.', columns: 10 },
									{ name: 'b', columns: 4 },
									{ name: '.', columns: 10 },
									{ name: '.', columns: 7 },
									{ name: 'c', columns: 10 },
									{ name: '.', columns: 7 },
								],
							}}
							allowOverflowingContent
						>
							<Container
								padding={{ bottom: ContainerPadding.dynamic0200 }}
								horizontalAlign={'center'}
								verticalAlign={'center'}
								wrap={'always'}
							>
								<Container
									padding={{ bottom: ContainerPadding.dynamic0130 }}
									horizontalAlign={'center'}
									verticalAlign={'center'}
									wrap={'always'}
								>
									<Text
										appearance={TokenTextAppearance.headline400}
										textAlign={TextAlignment.center}
										color={TokenTextColor.primary}
									>
										Estás a un solo paso...
									</Text>
								</Container>
								<Text
									appearance={TokenTextAppearance.copy200}
									textAlign={TextAlignment.center}
									color={TokenTextColor.primary}
								>
									Al registrarte aceptas las{' '}
									<CTA tag="a" emphasis="tertiary" onClick={handleOnClick} target="_blank">
										<Text appearance={TokenTextAppearance.copy200} color={TokenTextColor.primary}>
											Condiciones de uso de Club Volkswagen{' '}
										</Text>
									</CTA>
									. Puedes acceder a nuestra{' '}
									<CTA
										tag="a"
										emphasis="tertiary"
										href="https://www.volkswagen.es/es/volkswagen-espana/politica-privacidad.html"
										target="_blank"
										onClick={() => {
											trackingManager.trackClubVWLinkClick(
												'Política de privacidad',
												{
													contentId: 'Navigate to privacy policy',
												},
												{ vehicle: [] },
											);
										}}
									>
										<Text appearance={TokenTextAppearance.copy200} color={TokenTextColor.primary}>
											Política de Privacidad.
										</Text>
									</CTA>
								</Text>
							</Container>

							<Container padding={{ bottom: ContainerPadding.dynamic0200 }} horizontalAlign={'center'} stretchContent>
								<CTA
									tag="button"
									emphasis="primary"
									aria-label="Unirme al club"
									stretchContent
									size="large"
									onClick={() => {
										handleSubmit();
									}}
								>
									Unirme al club
								</CTA>
							</Container>

							<Container wrap={'always'} gutter={ContainerGutter.static250} horizontalAlign={'center'}>
								<Text
									appearance={TokenTextAppearance.label150}
									color={TokenTextColor.secondary}
									textAlign={TextAlignment.center}
								>
									El responsable del tratamiento es Volkswagen Group España Distribución. Con el registro al Club
									Volkswagen recibirás comunicaciones y encuestas asociadas al Club Volkswagen sobre nuestros productos
									y servicios, promociones y últimas novedades. Si lo deseas, puedes desactivar el envío de estas
									comunicaciones en el apartado “Ajustes de mi membresía del Club Volkswagen”. Puedes ejercer tus
									derechos según se indica en la{' '}
									<CTA
										tag="a"
										emphasis="tertiary"
										href="https://www.volkswagen.es/es/volkswagen-espana/politica-privacidad.html"
										target="_blank"
										onClick={() => {
											trackingManager.trackClubVWLinkClick(
												'Política de privacidad',
												{
													contentId: 'Navigate to privacy policy',
												},
												{ vehicle: [] },
											);
										}}
									>
										<Text appearance={TokenTextAppearance.label150} color={TokenTextColor.secondary}>
											Política de Privacidad
										</Text>
									</CTA>
									.
								</Text>
							</Container>
						</Layout>
					</StyledContainer>
				</Container>
			)}
		</>
	);
};
